export const PARTICIPANT_CATEGORIES = [
  "VIP",
  "Exposant",
  "Prestataire",
  "Presse",
  "Speaker",
  "Jury",
  "Coach",
  "Sponsor",
  "Partenaire",
  "Membre du personnel",
];

export const STRUCTURE_TYPES = [
  "Entreprise",
  "Association",
  "Centre de formation/Université",
  "Collectivité/Établissement public",
  "Autre",
];

export const PROVIDER_TYPES = [
  "Lieu de réception",
  "Hébergement",
  "Matériel",
  "Décoration",
  "Traiteur",
  "Animation",
  "Musique",
  "Photographie",
  "Technique",
  "Service",
  "Transport",
  "Communication",
  "Assurance",
];

export const EXPENSE_TYPES = [
  ...PROVIDER_TYPES,
  "Frais bancaires",
  "Divers",
];

export const TRANSPORT_OPTIONS = [
  "Marche",
  "Vélo",
  "Voiture",
  "Covoiturage",
  "Navette (si disponible)",
  "Transports en commun",
  "Avion",
  "Je ne sais pas encore",
];

export const EVENT_ACCESS_OPTIONS = [
  "Marche",
  "Vélo",
  "Voiture",
  "Covoiturage",
  "Navette",
  "Transports en commun",
  "Avion",
  "Je ne sais pas encore",
];

export const PROVIDER_TYPE_HINTS = [
  "Technique : sonorisation, audiovisuel, éclairage, streaming.",
  "Service : hôtesse d'accueil, sécurité, coach, interprète, facilitateur, régisseur.",
  "Décoration : scénographie, signalétique, fleuriste.",
  "Matériel : tables, chaises, stands, badges, mobilier.",
  "Communication : publicité, site web, relations presse, graphisme.",
  "Transport : navettes, véhicules, voiturier.",
  "Animation : coach, speaker, artiste, team building.",
];